import MaybeSpinner from "../../tools/MaybeSpinner";

function ProjectSkeleton() {
	return <MaybeSpinner  loading={true}>
		<></>
	</MaybeSpinner>;
}

export default ProjectSkeleton;
